module.exports = __webpack_public_path__ + "media/images/crm/content-illustration-6-5b676e8a7c5210c12c7838216e4a89fd.png";